export const EPR_START_GUIDE_STORAGE_KEY = "lappa.epr.startGuide.v1";

const EMPTY_STATE = { completed: {}, dismissed: false };

export function readEprStartGuideState() {
  if (typeof window === "undefined") return { ...EMPTY_STATE, completed: {} };

  try {
    const raw = window.localStorage.getItem(EPR_START_GUIDE_STORAGE_KEY);
    if (!raw) return { ...EMPTY_STATE, completed: {} };
    const parsed = JSON.parse(raw);
    const completed =
      parsed && parsed.completed && typeof parsed.completed === "object"
        ? parsed.completed
        : {};
    return {
      completed,
      dismissed: Boolean(parsed && parsed.dismissed),
    };
  } catch {
    return { ...EMPTY_STATE, completed: {} };
  }
}

export function writeEprStartGuideState(state) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(
    EPR_START_GUIDE_STORAGE_KEY,
    JSON.stringify({
      completed: state.completed || {},
      dismissed: Boolean(state.dismissed),
    })
  );
}
